import httpRequest from "@/auth/http-client";
import { buildPaginationQuery, buildSortQuery } from "@/helpers/request-helpers";
import { ICustomerSalesProductPayment } from "@/interfaces/customer-sales-product-payment.interfaces";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

const DEFAULT_PAYMENT_FILTER_SORT_BY = "billingDate";
const DEFAULT_PAYMENT_FILTER_SORT_DIRECTION = "desc";

class CustomerSalesProductPaymentService {
  private baseUrl = "api/v1/customersalesproductpayments";

  async filter(
    filter: IFilter<ICustomerSalesProductPayment>[],
    pagination: RequestPagination,
    sortBy: string | null = DEFAULT_PAYMENT_FILTER_SORT_BY,
    sortDirection: string | null = DEFAULT_PAYMENT_FILTER_SORT_DIRECTION
  ): Promise<PaginatedResponse<ICustomerSalesProductPayment>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const resolvedSortBy = sortBy?.trim() || DEFAULT_PAYMENT_FILTER_SORT_BY;
    const resolvedSortDirection = sortDirection?.trim() || DEFAULT_PAYMENT_FILTER_SORT_DIRECTION;
    const sortQuery = buildSortQuery(resolvedSortBy, resolvedSortDirection);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}${sortQuery}`, {
      filter,
      sortBy: resolvedSortBy,
      sortDirection: resolvedSortDirection,
    });

    return response;
  }

  async getById(customerSalesProductPaymentId: number): Promise<ICustomerSalesProductPayment> {
    // Chamada direta ao endpoint Backoffice/T2B por ID
    const customerSalesProductPayment = await httpRequest.get<ICustomerSalesProductPayment>(
      `${this.baseUrl}/${customerSalesProductPaymentId}`
    );
    return customerSalesProductPayment;
  }
}

const customerSalesProductPaymentService = new CustomerSalesProductPaymentService();
export default customerSalesProductPaymentService;
